import { PartitionOutlined } from '@ant-design/icons';
import { validateProductOwner, validateAllActiveProducts } from './utils';

import messages from 'i18n/messages/home';

import { RibbonButton } from 'common/components';
import { useGlobalModal } from 'hooks';

import { useUserInfo } from 'hooks/auth/useUserInfo';
import { useCheckBrokerPermissions } from 'hooks/impersonate/useCheckBrokerPermissions';

import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';

const GDSNPublication = ({
  products,
  isFullView = false,
  productFull = {},
}) => {
  const { userInfo } = useUserInfo();

  const { MODAL_NAMES, openModal } = useGlobalModal();

  const someIsProductOverlay =
    products?.length > 0 &&
    products.some((productItem) => productItem.isOverlayProduct === true);

  const canBrokerPublishGdsn = useCheckBrokerPermissions([
    {
      action: ABILITY_ACTION.MAINTAIN,
      subject: ABILITY_SUBJECT.SYNDICATION,
    },
  ]);

  const checkEnabledGDSNPublishGrid = (products, isRivirGdsnParty) => {
    /*
      Enabled Condition:
      - All owner products or Broker impersonate has permission manage syndication
      - All Products active
      - Not Product Overlay
      - isRivirGdsnParty
    */

    if (products?.length === 0) return false;

    const isOwner = validateProductOwner(products);
    const allActiveProducts = validateAllActiveProducts(products);
    const isRIVIRGdsnParty = Boolean(isRivirGdsnParty);

    return (
      (isOwner || canBrokerPublishGdsn) &&
      allActiveProducts &&
      isRIVIRGdsnParty &&
      !someIsProductOverlay
    );
  };

  const checkEnableGDSNPublishFull = (isRivirGdsnParty) => {
    const isOwner = Boolean(productFull?.isOwner);
    const isActive = Boolean(productFull?.status?.toLowerCase() === 'active');
    const isRIVIRGdsnParty = Boolean(isRivirGdsnParty);
    const isOverlayProduct = productFull?.isOverlayProduct;

    return (
      (isOwner || canBrokerPublishGdsn) &&
      isActive &&
      isRIVIRGdsnParty &&
      !isOverlayProduct
    );
  };

  return (
    <>
      <RibbonButton
        size='small'
        className='button-item-dropdown'
        icon={<PartitionOutlined />}
        label={messages.GDSNPublicationSetup}
        onClick={() => openModal(MODAL_NAMES.PUBLICATION_SETUP_MODAL)}
        disabled={
          isFullView
            ? !checkEnableGDSNPublishFull(userInfo?.isRivirGdsnParty)
            : !checkEnabledGDSNPublishGrid(products, userInfo?.isRivirGdsnParty)
        }
      />
    </>
  );
};

export default GDSNPublication;
